export enum SupportType {
  choose = "select",
  GiveCompliment = "give compliment",
  MakeSuggestion = "make a suggestion",
  ReportProblem = "report a problem",
  MakeInquiry = "make inquiry",
}
